module.exports = __webpack_public_path__ + "assets/img/1f8cd43b77756817409685b3a35a7093.png";